<template>
  <el-table :data="orders">
    <el-table-column label="订单号">
      <template #default="scope">
        {{ scope.row.orderNo }}
      </template>
    </el-table-column>
    <el-table-column label="订单类型">
      <template #default="scope">
        {{ getResourceType(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column label="名称">
      <template #default="scope">
        <el-link :href="getUrl(scope.row)" :underline="false" target="_blank" type="primary">
          {{ scope.row.resourceTitle }}
        </el-link>
      </template>
    </el-table-column>
    <el-table-column label="金额" align="center">
      <template #default="scope">￥{{ scope.row.amount.toFixed(2) }}</template>
    </el-table-column>
    <el-table-column label="支付方式" align="center">
      <template #default="scope">
        {{ getChannel(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column label="支付时间" align="center">
      <template #default="scope">
        {{ scope.row.createdDate }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IOrder } from '@/types/models';
import utils from '@/utils';

export default defineComponent({
  props: {
    orders: {
      type: Object as PropType<IOrder[]>,
      required: true,
    },
  },
  methods: {
    getResourceType(item: IOrder) {
      return utils.getResourceType(item.resourceType);
    },

    getChannel(item: IOrder) {
      return utils.getPayChannel(item.channel);
    },

    getUrl(item: IOrder) {
      return utils.getResourceUrl(item.resourceType, item.resourceId);
    },
  },
});
</script>
